export default __webpack_public_path__ + "da57479c317e69bfd691e7c5d5ba7e76.png";